import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useToggle from 'academy-common-lib/hooks/useToggle';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { useCallback } from 'react';
import { refetchAssignments, useDeletePlaylistAssignment, usePlaylistAssignments } from '../playlistAssignmentsQueries';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import I18n from 'I18n';
import UsageTracker from '../../../utils/UsageTracker';
import { useUserInfo } from '../../accounts';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const UnAssignPlaylistButton = ({
  assignments,
  children = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.common.unassignAll"
  }),
  onDeleted,
  onClick,
  render = ({
    handleOnClick
  }) => /*#__PURE__*/_jsxs(Button, {
    onClick: handleOnClick,
    use: "link",
    children: [/*#__PURE__*/_jsx(DeleteIcon, {}), children]
  })
}) => {
  const {
    isShowing,
    show,
    hide
  } = useToggle();
  const {
    userInfo,
    userInfoLoading
  } = useUserInfo();
  const {
    playlistAssignments,
    playlistAssignmentsLoading
  } = usePlaylistAssignments({
    assignmentIds: assignments
  });
  const {
    deletePlaylistAssignment,
    deletePlaylistAssignmentLoading
  } = useDeletePlaylistAssignment();
  const handleDelete = useCallback(async () => {
    const deletedSelf = (playlistAssignments || []).find(assignment => {
      return userInfo && userInfo.user.id === assignment.assignee.userId;
    }) !== undefined;
    const numberOfAssignmentsDeleted = assignments.length;
    await Promise.all(assignments.map(async assignmentId => await deletePlaylistAssignment({
      assignmentId
    }))).then(async () => {
      await refetchAssignments();
      UsageTracker.track('playlistInteraction', {
        action: 'playlist-unassigned',
        assignee: deletedSelf,
        numberOfSelected: numberOfAssignmentsDeleted
      });
    }).catch(() => {
      FloatingAlertStore.addAlert({
        message: I18n.text('learningCenter.playlists.unassignUsersErrorMessage'),
        titleText: I18n.text('learningCenter.playlists.unassignUsersErrorTitle'),
        type: 'danger'
      });
    }).finally(() => {
      hide();
      if (onDeleted) {
        onDeleted();
      }
    });
  }, [assignments, deletePlaylistAssignment, hide, onDeleted, playlistAssignments, userInfo]);
  const handleOnClick = e => {
    show();
    if (onClick) onClick(e);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [render({
      handleOnClick
    }), isShowing && /*#__PURE__*/_jsxs(Modal, {
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.unassignUser"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: hide
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.unassignExplanationOne"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.unassignExplanationTwo"
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: deletePlaylistAssignmentLoading || playlistAssignmentsLoading || userInfoLoading,
          onClick: () => void handleDelete(),
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.unassignUser"
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: deletePlaylistAssignmentLoading,
          onClick: hide,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.common.cancel"
          })
        })]
      })]
    })]
  });
};